import { render } from "./InputStaffList.vue?vue&type=template&id=a1976d38"
import script from "./InputStaffList.vue?vue&type=script&lang=js"
export * from "./InputStaffList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__